/** Classes Tailwind pour les statuts brouillon / disponible / indisponible dans les tableaux. */
export const badgeClasses = {
  primary:
    "inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200",
  success:
    "inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
  error:
    "inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
  warning:
    "inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300",
  info:
    "inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300",
  secondary:
    "inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-900/40 dark:text-gray-300",
};

export const boolBadgeClasses = (bool?: boolean): string => {
  if (bool === undefined || bool === null) return "";
  return bool ? badgeClasses.success : badgeClasses.error;
};
